import { STOModel } from "src/models/base/sto-model";
import { AnomalyLastNotificationAndSignoffDTO } from "src/models/tna/tna-anomalies/anomaly-last-notification-signoff/anomaly-last-notification-signoff-dto";
import { BaseApiService } from "../base";

export class AnomalyLastNotificationAndSignoff extends BaseApiService<AnomalyLastNotificationAndSignoffDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/Anomaly",
      loadItemsPath: "/AnomalyLastNotificationAndSignoffDTO",
    });

    // this.defaultSort = [
    //   {
    //     name: "date",
    //     direction: ListSortDirection.Descending,
    //   } as Sort,
    // ];
  }
}
